import { render } from "./UserProfileDialog.vue?vue&type=template&id=eddcfede&scoped=true"
import script from "./UserProfileDialog.vue?vue&type=script&lang=js"
export * from "./UserProfileDialog.vue?vue&type=script&lang=js"

import "./UserProfileDialog.vue?vue&type=style&index=0&id=eddcfede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddcfede"]])

export default __exports__